import React from "react";
import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import officePlaceHolderImage from "../../../assets/images/business-image-placeholder.png";
import { BusinessData } from "../../../types";
import HomeCards from "../../../pages/customer/homeCards";

interface Props {
  business: BusinessData;
  onSelect: () => void;
}

const BusinessInfo: React.FC<Props> = React.memo(({ business, onSelect }) => {
  const navigate = useNavigate();
  const businessBasic = business.businessBasic;
  return (
    <React.Fragment>
      {businessBasic && (
        <Button
          onClick={() => {
            onSelect();
            navigate(`/${businessBasic.url}`);
          }}
        >
          <HomeCards
            title={businessBasic.name}
            description={
              businessBasic.address ? `${businessBasic.address}` : ""
            }
              image={
                (business.businessBasic?.images && business.businessBasic?.images[0]?.url) ?? officePlaceHolderImage
              }
          />
        </Button>
      )}
    </React.Fragment>
  );
});

export default BusinessInfo;